
define('text!templates/parts/modal/create-test-client-modal.html',[],function () { return '{{#t}}In order to go through this walkthrough, you need to have added yourself as a test client.{{/t}}\n<br />\n<a class="add-test-client" href="#">\n    {{#t}}Click here to add yourself as a test client.{{/t}}\n</a>\n';});

